import {Products} from './product';

export class ShoppingCartItem {
    $key : string;
   title:string;
   imageUrl:string;
    price:number;
    quantity: number;

    constructor(init? : Partial<ShoppingCartItem>){
        Object.assign(this, init);
    }

    get totalPrice(){
        return this.price * this.quantity;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/shopping-cart-item.ts